import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SpinnerOverlayComponent } from './spinner-overlay.component';



@NgModule({
  declarations: [
    SpinnerOverlayComponent,
  ],
  exports: [
    SpinnerOverlayComponent,
  ],
  imports: [
    CommonModule,
  ],
})
export class SpinnerOverlayModule { }
